import { createAction, union } from '@ngrx/store';
import { DialogPayload } from './dialog.model';

export const vshcDialogOpen = createAction(
  '[@vshapps/libs/dialog] open',
  ({ key, meta }: DialogPayload) => ({ key, meta })
);
export const vshcDialogClose = createAction(
  '[@vshapps/libs/dialog] close',
  ({ key, meta }: DialogPayload) => ({ key, meta })
);
export const vshcDialogToggle = createAction(
  '[@vshapps/libs/dialog] toggle',
  ({ key, meta }: DialogPayload) => ({ key, meta })
);

const all = union({ open: vshcDialogOpen, close: vshcDialogClose, toggle: vshcDialogToggle });
export type DialogActionUnion = typeof all;
